// This composable provides structured data for the footer links, organized into groups for better maintainability and scalability.

export interface FooterMenuLink {
  label: string;
  to: string;
  external?: boolean;
  i18n?: boolean;
}

export interface FooterMenuGroup {
  key: string;
  title: string;
  links: FooterMenuLink[];
}

export function useFooterLinks() {
  const aposte: FooterMenuGroup = {
    key: 'aposte',
    title: 'Aposte',
    links: [
      { label: 'Apostas Esportivas', to: '/sports?tab=Early' },
      { label: 'Esportes ao Vivo', to: '/sports?tab=Live' },
      { label: 'Jogos Slots', to: '/games/category/all?initialCategory=slots' },
      {
        label: 'Jogos ao Vivo',
        to: '/games/category/all?initialCategory=jogos-ao-vivo',
      },
    ],
  };

  const comunidade: FooterMenuGroup = {
    key: 'comunidade',
    title: 'Comunidade',
    links: [
      { label: 'Promoções', to: '/promotions' },
      { label: 'Blog', to: '/blog' },
      {
        label: 'Central de Ajuda',
        to: 'https://ajuda.apostatudo.bet.br/',
        external: true,
      },
      { label: 'Canais de Atendimento', to: '/help' },
      {
        label: 'Aplicativo móvel',
        to: 'https://download.apostatudo.bet/',
        external: true,
      },
      {
        label: 'Acesse Nosso Telegram',
        to: "https://t.me/+k5vUd25dNs8yNGU5'",
        external: true,
      },
    ],
  };

  const regras: FooterMenuGroup = {
    key: 'regras',
    title: 'Regras',
    links: [
      { label: 'Termos e condições', to: '/page/terms' },
      { label: 'Política de PLD/FTP', to: '/page/pld-ftp-policy' },
      { label: 'Jogo Responsável', to: '/page/responsible-gaming' },
      {
        label: 'Política de comunicação marketing e anúncio',
        to: '/page/aml-policy',
      },
      { label: 'Política de avaliação de risco', to: '/page/kyc-policy' },
      { label: 'Política de investigação', to: '/page/lgpd' },
      {
        label: 'Politica de deveres do agente operador de apostas',
        to: '/page/betting-terms',
      },
      { label: 'Política de Privacidade', to: '/page/privacy' },
    ],
  };

  return { aposte, comunidade, regras };
}
